import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CondominiumService, Condominium } from '../../services/condominium.service';

@Component({
    selector: 'app-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.sass'],
    standalone: false
})
export class InfoComponent implements OnInit {
  condominium: Condominium | null = null;

  constructor(
    private route: ActivatedRoute,
    private condominiumService: CondominiumService
  ) {}

  ngOnInit(): void {
    const idParam = this.route.parent?.snapshot.paramMap.get('id');
    const condominiumId = idParam ? Number(idParam) : NaN;
    if (!isNaN(condominiumId)) {
      this.condominiumService.getCondominiumDetails(condominiumId).subscribe({
        next: (condominium) => this.condominium = condominium
      });
    }
  }
}


